var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearnMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1.241 2.38a.414.414 0 00-.413.413v4.965c0 .229.185.414.413.414h8.276a.414.414 0 00.414-.414V6.103a.414.414 0 01.828 0v1.655c0 .686-.556 1.242-1.242 1.242H1.241A1.241 1.241 0 010 7.758V2.793c0-.686.556-1.241 1.241-1.241h4.966a.414.414 0 010 .827H1.24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7.8.31h3.78a.42.42 0 01.42.42v3.78a.42.42 0 01-.84 0V1.746L6.924 5.98a.42.42 0 11-.594-.594l4.236-4.236H7.8a.42.42 0 010-.84z"
  })));
}
SvgLearnMore.displayName = 'LearnMore';
export default SvgLearnMore;